import { jsx as _jsx } from "react/jsx-runtime";
import { TableRow, TableCell, Typography } from '@mui/material';
const NoResultsFound = ({ colLength }) => {
    return (_jsx(TableRow, { children: _jsx(TableCell, Object.assign({ colSpan: colLength, height: "300px", align: 'center' }, { children: _jsx(Typography, Object.assign({ variant: 'h1' }, { children: "No results Found" })) })) }));
};
export default NoResultsFound;
